import {Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {MatStepper, MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import Swal from 'sweetalert2';

import {MatCheckboxModule} from '@angular/material/checkbox';
import {CommonModule} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {HeaderComponent} from '../../header/header.component';
import {FooterComponent} from '../../footer/footer.component';
import {DireccionDirective} from '../../../validaciones/directives/direccion.directive';
import {NameDirective} from '../../../validaciones/directives/name.directive';
import {NumericDirective} from '../../../validaciones/directives/numeric.directive';
import {AlphanumericDirective} from '../../../validaciones/directives/alphanumeric.directive';
import {PlacaDirective} from '../../../validaciones/directives/placa.directive';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconModule} from '@angular/material/icon';
import {validadorReutilizable} from '../../../shared/utils/validadores';
import {SolicitudVo} from '../../../pojos/solicitudVo';
import {combineLatest, debounceTime, distinctUntilChanged, filter, startWith, Subscription} from 'rxjs';

import { EstatusVehiculoResponse } from '../../../pojos/estatusVehiculoResponse';
import { CatEfectoCertificado } from '../../../service/catEfectoCertificado.service';
import { CatCoberturaCertificados } from '../../../service/catCoberturaCertificados.service';
import { ConsultarEstatusVehiculoService } from '../../../service/consultarEstatusVehiculoFisica.service';
import { HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { DefaultErrorMessage, ErrorMessages } from '../../catalogoErrores/error-messages';
import { SolicitarCertificado } from '../../../service/solicitarCertificadoEstatalFisica.service';
import { ConfirmarInformacionPropietario } from '../../../service/confirmarInformacionPropietarioFisica.service';
import { response } from 'express';
import { ResponsePropietarioFisica } from '../../../pojos/responsePropietarioFisica';
import { ImprimirSolicitudCdniGenerico } from '../../../service/imprimirSolicitudCdniGenerico.service';
import { DocumentoService } from '../../../service/cargarDocumentos.service';
import { EliminarDocumentos } from '../../../service/eliminarDocumentos.service';
import { VehiculoErrorResponseVo } from '../../../pojos/estatusVehiculoResponseMorales';


@Component({
  selector: 'app-persona-fisica-estatal',
  imports: [
    ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatOptionModule,
    HeaderComponent,
    FooterComponent,
    MatCheckboxModule,
    FormsModule,
    CommonModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,

    DireccionDirective,
    NameDirective,
    NumericDirective,
    AlphanumericDirective,
    PlacaDirective,
  ],
  templateUrl: './persona-fisica-estatal.component.html',
  styleUrl: './persona-fisica-estatal.component.css',
})
export class PersonaFisicaEstatalComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;

  @Input() solicitudVo!: SolicitudVo;
  @Input() estatusVehiculoResponse!: EstatusVehiculoResponse;
  @Input() efectosCertificados: any[] = [];
  @Input() coberturaCertificados: any[] = [];
  uploadProgress: number[] = [0, 0, 0, 0];
  isUploading: boolean[] = [false, false, false, false];
  documentos = [
    {id: 8, titulo: 'SOLICITUD DEL TRAMITE', formControlName: '',estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 3, titulo: 'FACTURA', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 4, titulo: 'INE', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 7, titulo: 'REPUVE', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
  ];
  nombreArchivos: string[] = ['', '', '', ''];
  documentosSubidos: { identificador: string; idDocumento: number; }[] = [];
  identificadoresAnteriores: string[] = []; // <-- ya lo manejas por índice
  idsDocumentoAnteriores: number[] = [];   // <-- también por índice
  private readonly STORAGE_KEY = 'persona-fisica-estatal-progress';
  //********************************************* INICIALIZADOR DE FORMGROUP ************************************************//

  PrimerFormGroup!: FormGroup;
  SegundoGrupo!: FormGroup;
  TercerFormGroup!: FormGroup;
  CuartoFormGroup!: FormGroup;
  QuintoFormGroup!: FormGroup;
  SextoFormGroup!: FormGroup;

  mostrarSpinner = false;
  isLinear = false;

  //********************************************* VARIABLES INICIALIZADAS PARA DOCUMENTOS PDF - IFRAME ************************************************//

  // SOLICITUD
  archivoPDF1: File | null = null;
  pdfURL1: any = null;
  // isUploading = false;
  // uploadProgress = 0;

  // FACTURA
  archivoPDF2: File | null = null;
  pdfURL2: any = null;
  isUploading2 = false;
  uploadProgress2 = 0;

  // INE
  archivoPDF3: File | null = null;
  pdfURL3: any = null;
  isUploading3 = false;
  uploadProgress3 = 0;

  // REPUVE
  archivoPDF4: File | null = null;
  pdfURL4: any = null;
  isUploading4 = false;
  uploadProgress4 = 0;
  subscription!: Subscription;
  bolHomoClaveCampo = false;
  bolDisableCampo = false;

  constructor(
    private _formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private consultarEstatusVehiculoService: ConsultarEstatusVehiculoService,
    private catEfectoCertificadoService: CatEfectoCertificado,
    private catCoberturaCertificadoService: CatCoberturaCertificados,
    private solicitarCertificadoCervice: SolicitarCertificado,
    private confirmarInformacionPropietarioService: ConfirmarInformacionPropietario,
    private imprimirSolicitudCdniGenerico: ImprimirSolicitudCdniGenerico,
    private cargarDocumentosService: DocumentoService,
    private eliminarDocumentosService: EliminarDocumentos
  ) {

     this.solicitudVo = new SolicitudVo();
      this.catCoberturaCertificados();
      this.catEfectoCertificado();

  }


  //********************************************* VARIABLES INICIALIZADAS PARA VALIDAR CAMPOS VACIOS ************************************************//

  ngOnInit(): void {

    this.PrimerFormGroup = this._formBuilder.group({
      niv: [
        '',
        [
          Validators.required,
          validadorReutilizable({
            blnPermitirLetras: true,
            blnPermitirNumeros: true,
            intLongitudMinima: 5,
            intLongitudMaxima: 17
          })
        ],
      ],
      placa: [
        '',
        [
          Validators.required,
          validadorReutilizable({

            blnPermitirLetras: true,
            blnPermitirNumeros: true,

            blnPermitirGuionMedio: true, // <- aquí activas el guion medio
            intLongitudMinima: 6,
            intLongitudMaxima: 10

          })
        ],
      ],

      motivoSolicitud: ['', Validators.required],
      certificadoPor: ['', Validators.required],
      tipoServicio: ['', Validators.required],
      categoria: [{value: '', disabled: true}],
      marca: [{value: '', disabled: true}],
      submarca: [{value: '', disabled: true}],
      modelo: [{value: '', disabled: true}],
      motor: [{value: '', disabled: true}],
      refrendo: [{value: '', disabled: true}],
      repuve: [{value: '', disabled: true}],
    });

    this.SegundoGrupo = this._formBuilder.group({
      rfc: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(13),
          Validators.pattern(/^[A-Z0-9]{8,13}$/),
        ],
      ],

      homoClave:[
        '',
        [
          Validators.required,
          validadorReutilizable({
            blnPermitirLetras: true,
            blnPermitirNumeros: true,
            intLongitudMinima: 3,
            intLongitudMaxima: 3
          })
        ],
      ],

      curp: [
        '',
        [
          Validators.required,
          Validators.minLength(18),
          Validators.maxLength(18),
          Validators.pattern(
            /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
          ),
          validadorReutilizable({
            blnPermitirLetras: true,
            blnPermitirNumeros: true,
            intLongitudMaxima: 18,
            blnPermitirEspacios: false,
            blnPermitirAcentos: false,
            blnPermitirPuntos: false,
            blnPermitirCaracteresEspecialesDireccion: false,
            blnPermitirCaracteresEspecialesEmpresa: false,
            strCompararConCampo: 'rfc', // Haz referencia al RFC
            strMensajeComparacion: 'Los primeros 10 caracteres del RFC y CURP no coinciden.',
            blnEsCURP: true,
          })
        ],
      ],
      nombre: [{value: '', disabled: true}],
      apellidoPaterno: [{value: '', disabled: true}],
      apellidoMaterno: [{value: '', disabled: true}],
      sexo: [{value: '', disabled: true}],
      fechaNacimiento: [{value: '', disabled: true}],
      calle: [{value: '', disabled: true}],
      numeroExterior: [{value: '', disabled: true}],
      numeroInterior: [{value: '', disabled: true}],
      codigoPostal: [{value: '', disabled: true}],
      estado: [{value: '', disabled: true}],
      municipio: [{value: '', disabled: true}],
      localidad: [{value: '', disabled: true}],
    });

    this.TercerFormGroup = this._formBuilder.group({
      numeroTelefono: [
        '',
        [Validators.required, Validators.pattern(/^\d{10}$/)],
      ],
      correoElectronico: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
    });

    this.CuartoFormGroup = this._formBuilder.group({
      descargarDocumento: [false, Validators.requiredTrue],
    });


    this.QuintoFormGroup = this._formBuilder.group({
      solicitud: ['', Validators.required],
      factura: ['', Validators.required],
      ine: ['', Validators.required],
      repuveDoc: ['', Validators.required],
    });

    this.SextoFormGroup = this._formBuilder.group({
      terminosCondiciones: [false, Validators.requiredTrue],
    });

  //********************************************* VALIDACIONES REACTIVAS 1-3 ************************************************//

    // 🔹 Aplicamos validaciones en tiempo real a TODOS los formularios
    this.inicializarValidacionesReactivas(this.PrimerFormGroup);
    this.inicializarValidacionesReactivas(this.SegundoGrupo);
    this.inicializarValidacionesReactivas(this.TercerFormGroup);
    this.inicializarValidacionesReactivas(this.CuartoFormGroup);
    this.inicializarValidacionesReactivas(this.QuintoFormGroup);
    this.inicializarValidacionesReactivas(this.SextoFormGroup);
//********************************************* VALIDACIONES DE CAMPOS 1-2 ************************************************//

    this.restaurarEstado();

    [
    this.PrimerFormGroup,
    this.SegundoGrupo,
    this.TercerFormGroup,
    this.CuartoFormGroup,
    this.QuintoFormGroup,
    this.SextoFormGroup
  ].forEach(form =>
    form.valueChanges
      .pipe(debounceTime(500))
      .subscribe(() => this.guardarEstado())
  );


//********************************************* VALIDACION DE NIV Y PLACA PARA OBTENER ESOS VALORES ************************************************//
      const nivControl = this.PrimerFormGroup.get('niv');
      const placaControl = this.PrimerFormGroup.get('placa');

      if (nivControl && placaControl) {
      combineLatest([
        nivControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()),
        placaControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()),
      ]).subscribe(([niv, placa]) => {
        // Valida ambos campos aquí
        //this.configurarReaccionNivYPlaca(this.PrimerFormGroup);
      });
    }


      this.subscription = this.PrimerFormGroup.valueChanges
  .pipe(
    debounceTime(2350),
    distinctUntilChanged((prev, curr) =>
      prev.niv === curr.niv && prev.placa === curr.placa
    ),
    filter(val => {
      const niv = val.niv?.trim() || '';
      const placa = val.placa?.trim() || '';

      // Reglas para NIV (puede ser 8, 9, 10, 11 o 17)
      const longitudesNivPermitidas = [7,8, 9, 10, 11,12,13,14,15,16,17];
      const nivValido = longitudesNivPermitidas.includes(niv.length);

      // Reglas para Placas (de 5 a 8 caracteres)
      const placaValida = placa.length >= 5 && placa.length <= 10;

      return nivValido && placaValida;
    })
  )
  .subscribe(val => {
    this.consultarEstatusVehiculo(val.niv, val.placa);
  });
//********************************************* VALIDACION DE NIV Y PLACA PARA OBTENER ESOS VALORES ************************************************//


//********************************************* VALIDACION DE RFC, HOMOCLAVE, CURP PARA OBTENER LOS VALORES Y CONSUMO DE SERVICIO *****************//
      const rfcControl = this.SegundoGrupo.get('rfc');
      const homoClaveControl = this.SegundoGrupo.get('homoClave');
      const curpControl = this.SegundoGrupo.get('curp');

      if (rfcControl && homoClaveControl && curpControl) {
      this.subscription = combineLatest([
      rfcControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()),
      homoClaveControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()),
      curpControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
    ]).subscribe(([rfc, homoclave, curp]) => {

      const rfcSinEspacios = rfc?.trim() || '';
      const homoclaveSinEspacios = homoclave?.trim() || '';
      const curpSinEspacios = curp?.trim() || '';


    if (rfcSinEspacios.length === 10 && homoclaveSinEspacios.length === 3 && curpSinEspacios.length === 18) {
      const strRfcIngresado = rfcSinEspacios;
      const strRfcEncontrado = rfcSinEspacios + homoclaveSinEspacios;
      const strCurp = curpSinEspacios;

      this.consultarInformacionPropietario(strRfcEncontrado ,strRfcIngresado, strCurp);
    }
      });
    }
//********************************************* VALIDACION DE RFC, HOMOCLAVE, CURP PARA OBTENER LOS VALORES Y CONSUMO DE SERVICIO ****************//
  }


   guardarEstado(): void {
  if (!this.stepper) return;

  const estado = {
    stepIndex: this.stepper.selectedIndex,

    forms: {
      primer: this.PrimerFormGroup.getRawValue(),
      segundo: this.SegundoGrupo.getRawValue(),
      tercero: this.TercerFormGroup.getRawValue(),
      cuarto: this.CuartoFormGroup.getRawValue(),
      quinto: this.QuintoFormGroup.getRawValue(),
      sexto: this.SextoFormGroup.getRawValue(),
    },

    documentos: this.documentos,
    identificadores: this.identificadoresAnteriores,
    idsDocumento: this.idsDocumentoAnteriores
  };

  sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(estado));
}


private restaurarEstado(): void {
  const saved = sessionStorage.getItem(this.STORAGE_KEY);
  if (!saved) return;

  const estado = JSON.parse(saved);

  this.PrimerFormGroup.patchValue(estado.forms.primer);
  this.SegundoGrupo.patchValue(estado.forms.segundo);
  this.TercerFormGroup.patchValue(estado.forms.tercero);
  this.CuartoFormGroup.patchValue(estado.forms.cuarto);
  this.QuintoFormGroup.patchValue(estado.forms.quinto);
  this.SextoFormGroup.patchValue(estado.forms.sexto);

  this.documentos = estado.documentos ?? this.documentos;
  this.identificadoresAnteriores = estado.identificadores ?? [];
  this.idsDocumentoAnteriores = estado.idsDocumento ?? [];

  setTimeout(() => {
    this.stepper.selectedIndex = estado.stepIndex ?? 0;
  });
}

  //******************METODOS y llamada a consumos de servicio********************************//

 consultarEstatusVehiculo(strNiv:string, strPlaca:string): void{
   this.mostrarSpinner = true;
  this.consultarEstatusVehiculoService.consultarEstatusVehiculo(strNiv,strPlaca).subscribe({
    next: (response: EstatusVehiculoResponse) =>{
        this.estatusVehiculoResponse = response;
        //console.log(response);

        if(this.estatusVehiculoResponse &&
          this.estatusVehiculoResponse.datosVehiculoResponseVo && Object.keys(this.estatusVehiculoResponse.datosVehiculoResponseVo).length > 0 &&
          this.estatusVehiculoResponse.datosPersonaResponseVo && Object.keys(this.estatusVehiculoResponse.datosPersonaResponseVo).length > 0 &&
          this.estatusVehiculoResponse.datosDomicilioResponseVo && Object.keys(this.estatusVehiculoResponse.datosDomicilioResponseVo).length > 0)
          {
        // Limpiar el formulario primero para evitar que los campos se queden sucios
          this.PrimerFormGroup.patchValue({
            categoria: '',
            marca: '',
            submarca: '',
            modelo: '',
            motor: '',
            refrendo: '',
            repuve: ''
          });

         this.PrimerFormGroup.patchValue({
          categoria: this.estatusVehiculoResponse.datosVehiculoResponseVo.strCategoria,
          marca: this.estatusVehiculoResponse.datosVehiculoResponseVo.strMarca,
          submarca: this.estatusVehiculoResponse.datosVehiculoResponseVo.strSubMarca,
          modelo: this.estatusVehiculoResponse.datosVehiculoResponseVo.strModelo,
          motor: this.estatusVehiculoResponse.datosVehiculoResponseVo.strMotor,
          refrendo: this.estatusVehiculoResponse.datosVehiculoResponseVo.strRefrendo,
          repuve: this.estatusVehiculoResponse.datosVehiculoResponseVo.strRepuve
        });

        this.SegundoGrupo.patchValue({
          rfc: this.estatusVehiculoResponse.datosPersonaResponseVo.strRfc,
          //curp: this.estatusVehiculoResponse.datosPersonaResponseVo.
          nombre: this.estatusVehiculoResponse.datosPersonaResponseVo.strNombre,
          apellidoPaterno: this.estatusVehiculoResponse.datosPersonaResponseVo.strApPaterno,
          apellidoMaterno: this.estatusVehiculoResponse.datosPersonaResponseVo.strApMaterno,
          sexo: this.estatusVehiculoResponse.datosPersonaResponseVo.strSexo,
          fechaNacimiento: this.estatusVehiculoResponse.datosPersonaResponseVo.strFechaNacimiento,
          calle: this.estatusVehiculoResponse.datosDomicilioResponseVo.strCalle,
          numeroExterior: this.estatusVehiculoResponse.datosDomicilioResponseVo.strNoExterior,
          numeroInterior: this.estatusVehiculoResponse.datosDomicilioResponseVo.strNoInterior,
          codigoPostal: this.estatusVehiculoResponse.datosDomicilioResponseVo.strCodigoPostal,
          estado: this.estatusVehiculoResponse.datosDomicilioResponseVo.strEstado,
          municipio: this.estatusVehiculoResponse.datosDomicilioResponseVo.strMunicipio,
          localidad: this.estatusVehiculoResponse.datosDomicilioResponseVo.strLocalidad
        });

        this.checkHomoClave();
        this.extractBirthday();

          Swal.fire({
          icon: 'info',
          title: 'Aviso del Vehículo',
          html: `<h4>Consulta correcta`,
          confirmButtonColor: '#04B404',
          confirmButtonText: 'Continuar',
          allowEscapeKey: false, // Deshabilita cerrar con ESC
          allowEnterKey: false, // Deshabilita cerrar con ENTER
          allowOutsideClick: false, // Deshabilita cerrar haciendo clic fuera
        });
      }else if (this.estatusVehiculoResponse.intCodigoMensaje === 402) {
        Swal.fire({
        icon: 'error',
        html: '<h4>No existe información relacionada con el NIV y PLACA. Verifique su información e inténtelo de nuevo.<br>Gracias.</p>',
        allowEscapeKey: false, // Deshabilita cerrar con ESC
        allowEnterKey: false, // Deshabilita cerrar con ENTER
        allowOutsideClick: false, // Deshabilita cerrar haciendo clic fuera
        }).then(() => {
          location.reload(); // Recargar la página después de confirmar
        //text: message,
        });
      }else if (this.estatusVehiculoResponse.vehiculoError?.strMensaje) {
        Swal.fire({
        icon: 'warning',
        title: 'Advertencia',
        html: `<b>Atención:</b> ${this.estatusVehiculoResponse.vehiculoError?.strMensaje}. <br><br>Si tienes dudas, asiste a tu oficina recaudadora más cercana.`,
        confirmButtonColor: '#04B404',
        confirmButtonText: 'Confirmar',
        allowEscapeKey: false,
        allowEnterKey: false,
        allowOutsideClick: false,
      }).then(() => {
                location.reload(); // Recargar la página después de confirmar
              });
      }else if (this.estatusVehiculoResponse.vehiculoErrorResponseVo?.strMensaje) {
        Swal.fire({
        icon: 'warning',
        title: 'Advertencia',
        html: `<b>Atención:</b> ${this.estatusVehiculoResponse.vehiculoErrorResponseVo?.strMensaje}. <br><br>Si tienes dudas, asiste a tu oficina recaudadora más cercana.`,
        confirmButtonColor: '#04B404',
        confirmButtonText: 'Confirmar',
        allowEscapeKey: false,
        allowEnterKey: false,
        allowOutsideClick: false,
      }).then(() => {
                location.reload(); // Recargar la página después de confirmar
              });

      }else if (this.estatusVehiculoResponse.intCodigoHttp === 400) {
          Swal.fire({
        icon: 'warning',
        title: 'Advertencia',
        html: `<b>Atención:</b> ${this.estatusVehiculoResponse.vehiculoError?.strMensaje}.`,
        confirmButtonColor: '#04B404',
        confirmButtonText: 'Confirmar',
        allowEscapeKey: false,
        allowEnterKey: false,
        allowOutsideClick: false,
      }).then(() => {
                location.reload(); // Recargar la página después de confirmar
              });
      }
      this.mostrarSpinner = false;

    },
    //estrcutura de error de ejemplo
    error: (error: HttpErrorResponse) =>{
      this.mostrarSpinner = false;
    let message = DefaultErrorMessage;

    if(error instanceof HttpErrorResponse){
      const statusCode = error.status;

      // Si viene un código de error personalizado desde el backend:
        const customCode = error.error?.codigo; // <- Esto depende de tu backend

        if(customCode && ErrorMessages[customCode]){
            message = ErrorMessages[customCode];
        }else if (ErrorMessages[statusCode]) {
          message = ErrorMessages[statusCode];
        }
      }
     Swal.fire({
        icon: 'error',
        title: 'Error',
        text: message,

    }).then(() => {
                location.reload(); // Recargar la página después de confirmar
              });

    }
  });
 }


 consultarInformacionPropietario(strRfcIngresado:string, strRfcEncontrado:string, strCurp:string){
  this.mostrarSpinner = true;
    this.confirmarInformacionPropietarioService.confirmarInformacionPropietario(strRfcIngresado,strRfcEncontrado,strCurp).subscribe({
      next:(resp: ResponsePropietarioFisica) =>{

        if(resp.intCodigoHttp === 200){
          Swal.fire({
          icon: 'success',
          //title: 'Información Encontrada',
          html: `<h4>${resp.strMensaje}`,
          confirmButtonColor: '#04B404',
          confirmButtonText: 'Continuar',
          allowEscapeKey: false, // Deshabilita cerrar con ESC
          allowEnterKey: false, // Deshabilita cerrar con ENTER
          allowOutsideClick: false, // Deshabilita cerrar haciendo clic fuera
        });
        }else if (resp.intCodigoHttp === 400) {
           Swal.fire({
          icon: 'error',
          //title: 'Información Encontrada',
          html: `<h4>${resp.strMensaje}`,
          confirmButtonColor: '#04B404',
          confirmButtonText: 'Continuar',
          allowEscapeKey: false, // Deshabilita cerrar con ESC
          allowEnterKey: false, // Deshabilita cerrar con ENTER
          allowOutsideClick: false, // Deshabilita cerrar haciendo clic fuera
        });
        }
        this.mostrarSpinner = false;
      },
       error: (error: HttpErrorResponse) =>{
                       this.mostrarSpinner = false;
                     let message = DefaultErrorMessage;

                     if(error instanceof HttpErrorResponse){
                       const statusCode = error.status;

                       // Si viene un código de error personalizado desde el backend:
                         const customCode = error.error?.codigo; // <- Esto depende de tu backend

                         if(customCode && ErrorMessages[customCode]){
                             message = ErrorMessages[customCode];
                         }else if (ErrorMessages[statusCode]) {
                           message = ErrorMessages[statusCode];
                         }
                       }
                     Swal.fire({
                         icon: 'error',
                         title: 'Error',
                         text: message,

                     }).then(() => {
                                 location.reload(); // Recargar la página después de confirmar
                               });

                     }
    });
 }



 ngOnDestroy(): void {
  this.subscription.unsubscribe();
 }





 catCoberturaCertificados(){
  this.catCoberturaCertificadoService.catCoberturaCertificado().subscribe({
    next: (data:any) => {
      this.coberturaCertificados = data;
    }
  });
 }


catEfectoCertificado(){
  this.catEfectoCertificadoService.catEfectoCertificado().subscribe({
    next: (data: any) => {
      this.efectosCertificados = data;
    }
  });
}


onChangeCoberturaCertificados(event:any){
  this.solicitudVo.strCertificadoPor = event.target.value;
}


onChangeEfectoCertificado(event:any){
  this.solicitudVo.strMotivoSolicitud = event.target.value;
}

onChangeTipoServicio(event:any){
  this.solicitudVo.strTipoServicio = event.target.value;
}

checkHomoClave() {
  const homoClaveControl = this.SegundoGrupo.get('homoClave');

  if(this.estatusVehiculoResponse.datosPersonaResponseVo.strRfc?.trim().length === 13){
    this.bolHomoClaveCampo = false;
    this.SegundoGrupo.get('rfc')?.disable();
    homoClaveControl?.clearValidators();
    homoClaveControl?.setValue('');
    homoClaveControl?.updateValueAndValidity();
  } else if (this.estatusVehiculoResponse.datosPersonaResponseVo.strRfc.trim().length < 13) {
    this.bolHomoClaveCampo = true;
    this.SegundoGrupo.get('rfc')?.disable();
    homoClaveControl?.setValidators([
      Validators.required,
      validadorReutilizable({
        blnPermitirLetras: true,
        blnPermitirNumeros: true,
        intLongitudMinima: 3,
        intLongitudMaxima: 3
      })
    ]);
  }
}

subirDocumento(rfc: string, idDocumento: number, archivo: File, index: number): void {
  this.documentos[index].estadoSubida ='SUBIENDO';
  this.cargarDocumentosService.subirDocumentoPdf(rfc, idDocumento, archivo).subscribe({
    next: (event: HttpEvent<any>) => {
      if (event.type === HttpEventType.UploadProgress && event.total){
        const progreso = Math.round((100 * event.loaded) / event.total);
        this.isUploading[index] = true;
        this.uploadProgress[index] = progreso;
      } else if (event.type === HttpEventType.Response) {
        this.isUploading[index] = false;

        this.documentos[index].estadoSubida = 'SUBIDO';

        const respuesta = event.body; // Aquí accedes a la respuesta del servicio


        this.identificadoresAnteriores[index] = respuesta.identificador;
        this.idsDocumentoAnteriores[index] = respuesta.idDocumento;

         Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: `${this.documentos[index].titulo} subido con éxito`,
          showConfirmButton: false,
          timer: 3000
        });
      }
    },
    error: () => {
      this.isUploading[index] = false;
      this.documentos[index].estadoSubida = 'ERROR';
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: `No se pudo subir el documento ${this.documentos[index].titulo}.`,
        showConfirmButton: false,
        timer: 3000
      });
    }
  });
}

 //******************METODOS y llamada a consumos de servicio********************************//






  //********************************************* VALIDACIONES REACTIVAS 2-3 ************************************************//

  private inicializarValidacionesReactivas(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((campo) => {
      formGroup.get(campo)?.valueChanges.subscribe(() => {
        this.actualizarEstilosCampo(campo);
      });
    });
  }

  //********************************************* VALIDACIONES REACTIVAS 3-3 ************************************************//

  private actualizarEstilosCampo(campo: string) {
    const control =
      this.SextoFormGroup.get(campo) ||
      this.QuintoFormGroup.get(campo) ||
      this.CuartoFormGroup.get(campo) ||
      this.TercerFormGroup.get(campo) ||
      this.SegundoGrupo.get(campo) ||
      this.PrimerFormGroup.get(campo);

      //if (!control || control.disabled) return;

      if(!control) return;

      const fieldElement = document.querySelector(`[formControlName="${campo}"]`) as HTMLElement;

      if (fieldElement) {
    
    if (control.value && (control.valid || control.disabled)) {
      fieldElement.classList.remove('is-invalid');
      fieldElement.classList.add('is-valid');
    }else if (!control.value) {
      fieldElement.classList.remove('is-valid');
      fieldElement.classList.remove('is-invalid');
    } else {
      fieldElement.classList.add('is-invalid');
      fieldElement.classList.remove('is-valid');
    }
  }
    // const fieldElement = document.querySelector(`[formControlName="${campo}"]`);

    // if (fieldElement) {
    //   if (control?.valid) {
    //     fieldElement.classList.remove('is-invalid');
    //     fieldElement.classList.add('is-valid');
    //   } else {
    //     fieldElement.classList.add('is-invalid');
    //     fieldElement.classList.remove('is-valid');
    //   }
    // }
  }

  //********************************************* STEPPER ************************************************//

  /** Validación y navegación **/
  validarYContinuar(campos: { grupo: FormGroup; nombres: string[] }) {
    let todosValidos = true;

    campos.nombres.forEach((campo) => {
      const control = campos.grupo.get(campo);
      const fieldElement = document.querySelector(
        `[formControlName="${campo}"]`
      );

      if(control){
        control.markAsTouched({onlySelf: true});
        control.updateValueAndValidity();
      }

      if (control && control.disabled) return;

      if (control && control.invalid && !control.disabled) {
        todosValidos = false;
        Swal.fire({
          html: this.mensajeError(campo),
          icon: 'warning',
          confirmButtonColor: '#A11A5C',
          confirmButtonText: 'Confirmar',
          didOpen: () => fieldElement?.classList.add('is-invalid'),
        });
      } else if (fieldElement && (control?.valid || control?.disabled)) {
        fieldElement.classList.remove('is-invalid');
        fieldElement.classList.add('is-valid');
      }
    });

    if (todosValidos) this.stepper.next();
  }

  //********************************************* MENSAJES PERSONALIZADOS ************************************************//

  mensajeError(campo: string): string {
    const mensajes: any = {
      niv: 'El campo <b> NIV de los Datos del Vehículo </b> no debe estar vacío.',
      placa:
        'El campo <b> Placa de los Datos del Vehículo </b> no debe estar vacío.',
      motivoSolicitud:
        'El campo <b> Motivo Solicitud de los Datos del Vehículo </b> debe estar seleccionado.',
      certificadoPor:
        'El campo <b> Certificado Por: de los Datos del Vehículo </b> debe estar seleccionado.',
      tipoServicio:
        'El campo <b> Tipo Servicio de los Datos del Vehículo </b> debe estar seleccionado.',
      rfc:
        'Por favor verifica que el campo <b> RFC </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000AAA',
        homoClave:
        'Por favor verifica que el campo <b> HOMOCLAVE </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>',
      curp:
        'Por favor verifica que el campo <b> CURP </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000LLLLLLA0',
      correoElectronico:
        'Por favor verifica que el campo <b> Correo Electrónico de los Medios de Contacto </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato correo: </b> nombre@ejemplo.com',
      numeroTelefono:
        'El campo <b> Número Teléfono de los Medios de Contacto </b> debe contener 10 números.',
      descargarDocumento:
        'Para continuar a la sección de <b>Documentos</b> primero debes marcar el cuadro que aparece en la parte inferior de esta sección',
      solicitud: 'El documento <b>SOLICITUD</b> no ha sido seleccionado',
      factura: 'El documento <b>FACTURA</b> no ha sido seleccionado',
      ine: 'El documento <b>INE</b> no ha sido seleccionado',
      repuveDoc: 'El documento <b>REPUVE</b> no ha sido seleccionado',
    };

    return mensajes[campo] || 'Campo inválido.';
  }

//***********************************************VALIDACIONES DE CAMPOS 2-2**********************************************//
  readonly camposDependientesVehiculo = [
    'categoria', 'marca', 'submarca', 'modelo',
    'motor', 'refrendo', 'repuve'
  ];

  marcarCamposVehiculoComoValidos(): void {
    this.camposDependientesVehiculo.forEach(campo => {
      const control = this.PrimerFormGroup.get(campo);
      if (control && control.disabled) {
      }
      control?.setErrors(null);
      control?.markAsTouched();
      control?.markAsDirty();
    });
  }

  resetearCamposVehiculo(): void {
    this.camposDependientesVehiculo.forEach(campo => {
      const control = this.PrimerFormGroup.get(campo);
      control?.reset({value: '', disabled: true});
    });
  }







  //********************************************* BOTONES SIGUIENTE ************************************************//

  nextButtonClick() {


    this.validarYContinuar({
      grupo: this.PrimerFormGroup,
      nombres: [
        'tipoServicio',
        'certificadoPor',
        'motivoSolicitud',
        'placa',
        'niv',
      ],
    });
  }

  nextButtonClick2() {
    this.validarYContinuar({
      grupo: this.SegundoGrupo,
      nombres: ['curp','homoClave', 'rfc'],
    });
  }

  nextButtonClick3() {
    this.validarYContinuar({
      grupo: this.TercerFormGroup,
      nombres: ['correoElectronico', 'numeroTelefono'],
    });
  }

  nextButtonClick4() {
    this.validarYContinuar({
      grupo: this.CuartoFormGroup,
      nombres: ['descargarDocumento'],
    });
  }

  nextButtonClick5() {
    this.validarYContinuar({
      grupo: this.QuintoFormGroup,
      nombres: ['repuveDoc', 'ine', 'factura', 'solicitud'],
    });
  }

   descargarDocumento() {

      const primerGrupo = this.PrimerFormGroup.getRawValue();
      const segundoGrupo = this.SegundoGrupo.getRawValue();

      const strNombreCompleto = `${segundoGrupo.nombre || ''} ${segundoGrupo.apellidoPaterno || ''} ${segundoGrupo.apellidoMaterno || ''}`.trim();
      const strRfc = `${segundoGrupo.rfc}${segundoGrupo.homoClave}`.trim();
      const strCurp = segundoGrupo.curp || '';

      const calle = segundoGrupo.calle || '';
      const numExt = segundoGrupo.numeroExterior || '';
      const numInt = segundoGrupo.numeroInterior || '';
      const codigoPostal = segundoGrupo.codigoPostal || '';
      const strDomicilio = `${calle} ${numExt}${numInt ? ' Int ' + numInt : ''}${codigoPostal}`.trim();

      const strMunicipio = segundoGrupo.municipio || '';
      const strEstado = segundoGrupo.estado || '';

      // Convertir ID a descripción para 'certificadoPor'
      const motivoSeleccionado = this.coberturaCertificados.find(
       m => m.id_cobertura_certificado == primerGrupo.certificadoPor
        );
const strGarantias = motivoSeleccionado?.certificado_por || '';
      const strNiv = primerGrupo.niv || '';
      const strPlaca = primerGrupo.placa || '';
      const strMarca = primerGrupo.marca || '';
      const strEstadoVehiculo = segundoGrupo.estado || '';
      const strModelo = primerGrupo.modelo || '';
      const strRefrendo = primerGrupo.refrendo || '';
      // Convertir ID a texto para 'tipoServicio'
const tipoServicioId = primerGrupo.tipoServicio;
const strTipoServicio = tipoServicioId === '1' ? 'PÚBLICO' : tipoServicioId === '2' ? 'PRIVADO' : '';
      const strNumeroMotor = primerGrupo.motor || '';
      const strRepuve = primerGrupo.repuve || '';
      const strRazonSocial = '';
      const strRfcRepresentante = '';
      const strTipoPersona = 'F';

    Swal.fire({
      html: `<h4>Descargando documento <b style="color: #A11A5C">SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN</b><hr>espere un momento...</h4>`,
      didOpen: () => {
        Swal.showLoading();
      },
      timer: 4000,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });

    //console.log(strEstado)
    this.imprimirSolicitudCdniGenerico.imprimirSolicitudCdniGenerico(
    strNombreCompleto,
    strRfc,
    strRfcRepresentante,
    strRazonSocial,
    strCurp,
    strDomicilio,
    strMunicipio,
    strEstado,
    strGarantias,
    strNiv,
    strPlaca,
    strMarca,
    strEstadoVehiculo,
    strModelo,
    strRefrendo,
    strTipoServicio,
    strNumeroMotor,
    strRepuve,
    strTipoPersona).subscribe({
      next: (blob: Blob) =>{
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'solicitud_cdni_estatal.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
        Swal.close();
      },
       error: (error) => {
      console.error();
      Swal.fire('Error', 'No se pudo generar el documento. Por favor, inténtelo de nuevo más tarde.', 'error');
    }
    });

  }


  nextButtonClick6() {

    this.validarYContinuar({
      grupo: this.SextoFormGroup,
      nombres: ['terminosCondiciones'],
    });

    const campo1 = this.SextoFormGroup.get('terminosCondiciones');

    const correo = this.TercerFormGroup.get('correoElectronico')?.value;

    if (campo1 && !campo1.value) {
      Swal.fire({
        html: '<b>Debes Aceptar los Términos y Condiciones</b>',
        icon: 'warning',
        confirmButtonColor: '#A11A5C',
        confirmButtonText: 'Confirmar',
      });
      return;
    }



    // Se obtiene los valores de todos los formularios con .getRawValue() (para incluir los campos disabled)
    const datosVehiculo = this.PrimerFormGroup.getRawValue();
    const datosPersona = this.SegundoGrupo.getRawValue();
    const datosContacto = this.TercerFormGroup.getRawValue();

    const objetoFinal = {
      "strNiv": datosVehiculo.niv,
      "strPlaca": datosVehiculo.placa,
      "intIdMotivoSolicitud": datosVehiculo.motivoSolicitud,
      "intIdCertificadoPor": datosVehiculo.certificadoPor,
      "intIdTipoServicio": datosVehiculo.tipoServicio,
      "intIdTipoTramite": 1,
      "strRfc": datosPersona.rfc + datosPersona.homoClave,
      "strCurp": datosPersona.curp,
      "strSexo": datosPersona.sexo,
      "strFechaNacimiento": datosPersona.fechaNacimiento,
      "strTelefono": datosContacto.numeroTelefono,
      "strEmail": datosContacto.correoElectronico
    }

    const objeto = JSON.stringify(objetoFinal);

    Swal.fire({
      title: '¿Estás seguro que deseas guardar la información?',
      icon: 'question',
      confirmButtonColor: '#04B404',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      showCancelButton: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        this.mostrarSpinner = true;
        this.solicitarCertificadoCervice.solicitarCertificdoEstatalFisica(objeto).subscribe({
        next: (res: ResponsePropietarioFisica) => {
          //console.log(res);
          if(res.intCodigoHttp === 200){

            sessionStorage.removeItem(this.STORAGE_KEY);

          Swal.fire({
          icon: 'success',
          title: 'Solicitud enviada',
          html: `Su solicitud ha sido enviada correctamente. <br><br>
         Se ha enviado un correo electrónico a la dirección proporcionada <b style="color: #A11A5C">${correo}</b> para darle seguimiento.
         <hr>Le recomendamos revisar su bandeja de entrada, así como la carpeta de spam o correo no deseado, en caso de no visualizar el mensaje.`,
          confirmButtonColor: '#04B404',
          confirmButtonText: 'Continuar',
          allowEscapeKey: false, // Deshabilita cerrar con ESC
          allowEnterKey: false, // Deshabilita cerrar con ENTER
          allowOutsideClick: false, // Deshabilita cerrar haciendo clic fuera
        });
          }else if (res.intCodigoHttp === 400) {
             Swal.fire({
            icon: 'error',
            title: 'Error al enviar datos',
            html: '<h4>No se pudo generar la solicitud. Verifique su información e inténtelo de nuevo.<br>Gracias.</p>',
            });
          }
          this.mostrarSpinner = false;
        },
        error: (error: HttpErrorResponse) =>{
                        this.mostrarSpinner = false;
                      let message = DefaultErrorMessage;

                      if(error instanceof HttpErrorResponse){
                        const statusCode = error.status;

                        // Si viene un código de error personalizado desde el backend:
                          const customCode = error.error?.codigo; // <- Esto depende de tu backend

                          if(customCode && ErrorMessages[customCode]){
                              message = ErrorMessages[customCode];
                          }else if (ErrorMessages[statusCode]) {
                            message = ErrorMessages[statusCode];
                          }
                        }
                      Swal.fire({
                          icon: 'error',
                          title: 'Error',
                          text: message,

                      }).then(() => {
                                  location.reload(); // Recargar la página después de confirmar
                                });

                      }
      })



      }
    });
  }

  //********************************** SOLICITUD *********************************************//

  onFileSelecteded1(input: HTMLInputElement, index: number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      this.archivoPDF1 = file;


        // const objectUrl = URL.createObjectURL(file);
        // this.pdfURL1 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
        // this.documentos[index].urlVisor = this.pdfURL1;
        // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc + datosPersona.homoClave;
      const idDocument = this.documentos[index].id;
      const doc = this.documentos[index];

      const nombreArchivoAnterior = this.identificadoresAnteriores[index];
      const idDocumentoAnterior = this.idsDocumentoAnteriores[index];

      const subir = () => {
      const objectUrl = URL.createObjectURL(file);
      const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

    // Solo aquí actualizas iframe y variables visuales
      this.archivoPDF1 = file;
      this.pdfURL1 = pdfSafeUrl;
      this.documentos[index].urlVisor = this.pdfURL1;
      this.documentos[index].rawUrl = objectUrl;

      this.subirDocumento(rfc, idDocument, file, index);
  };

      if (nombreArchivoAnterior) {
  // Mostrar confirmación al usuario
    Swal.fire({
    title: '¿Reemplazar archivo?',
    text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#41bd00',
    cancelButtonColor: '#C71128',
    confirmButtonText: 'Sí, reemplazar',
    cancelButtonText: 'No, cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      // Si el usuario confirma, eliminar el anterior
      this.eliminarDocumentosService.eliminarDocumentos(idDocumentoAnterior, rfc, nombreArchivoAnterior).subscribe({
        next: subir,
        error: () => {
          Swal.fire({
            icon: 'error',
            title: 'Error al eliminar documento anterior',
            text: `No se pudo eliminar el documento anterior para ${doc.titulo}.`,
            confirmButtonColor: '#A11A5C'
          });
        }
      });
    }
  });
} else {
  subir(); // Primera vez
  // Si no hay archivo anterior, subir directamente
  // this.subirDocumento(rfc, idDocument, file, index);
}
      //this.subirDocumento(rfc, idDocument, file, index);
  }
}


  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF1(event: Event, index: number): void {
    // console.log('Archivo seleccionado (evento):', event);

  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana1(): void {
    if (this.archivoPDF1) {
      const url = URL.createObjectURL(this.archivoPDF1);
      window.open(url, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** FACTURA *********************************************//

  onFileSelecteded2(input: HTMLInputElement, index: number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      this.archivoPDF2 = file;

      //  const objectUrl = URL.createObjectURL(file);
      //  this.pdfURL2 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      //  this.documentos[index].urlVisor = this.pdfURL2;
      //  this.documentos[index].rawUrl = objectUrl;

        const datosPersona = this.SegundoGrupo.getRawValue();

        const rfc = datosPersona.rfc + datosPersona.homoClave;
        const idDocument = this.documentos[index].id;
        const doc = this.documentos[index];

      const nombreArchivoAnterior = this.identificadoresAnteriores[index];
      const idDocumentoAnterior = this.idsDocumentoAnteriores[index];

      const subir = () => {
        const objectUrl = URL.createObjectURL(file);
        const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

        this.archivoPDF2 = file;
        this.pdfURL2 = pdfSafeUrl;
        this.documentos[index].urlVisor = this.pdfURL2;
        this.documentos[index].rawUrl = objectUrl;

        this.subirDocumento(rfc, idDocument, file, index);
      }

        if (nombreArchivoAnterior) {
               // Mostrar confirmación al usuario
                 Swal.fire({
                 title: '¿Reemplazar archivo?',
                 text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
                 icon: 'warning',
                 showCancelButton: true,
                confirmButtonColor: '#41bd00',
                cancelButtonColor: '#C71128',
                 confirmButtonText: 'Sí, reemplazar',
                 cancelButtonText: 'No, cancelar'
               }).then((result) => {
                 if (result.isConfirmed) {
                   // Si el usuario confirma, eliminar el anterior
                   this.eliminarDocumentosService.eliminarDocumentos(idDocumentoAnterior, rfc, nombreArchivoAnterior).subscribe({
                     next: subir,
                     error: () => {
                       Swal.fire({
                         icon: 'error',
                         title: 'Error al eliminar documento anterior',
                         text: `No se pudo eliminar el documento anterior para ${doc.titulo}.`,
                         confirmButtonColor: '#A11A5C'
                       });
                     }
                   });
                 }
               });
             } else {
              subir(); // Primera vez
               // Si no hay archivo anterior, subir directamente
              //  this.subirDocumento(rfc, idDocument, file, index);
             }

    }
  }

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF2(event: Event, index: number): void {
    // console.log('Archivo seleccionado (evento):', event);
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana2(): void {
    if (this.archivoPDF2) {
      const url = URL.createObjectURL(this.archivoPDF2);
      window.open(url, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** INE *********************************************//

  onFileSelecteded3(input: HTMLInputElement, index: number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      this.archivoPDF3 = file;

      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL3 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL3;
      // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc + datosPersona.homoClave;
      const idDocument = this.documentos[index].id;
      const doc = this.documentos[index];

      const nombreArchivoAnterior = this.identificadoresAnteriores[index];
      const idDocumentoAnterior = this.idsDocumentoAnteriores[index];

      const subir = () => {
        const objectUrl = URL.createObjectURL(file);
        const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

        this.archivoPDF3 = file;
        this.pdfURL3 = pdfSafeUrl;
        this.documentos[index].urlVisor = this.pdfURL3;
        this.documentos[index].rawUrl = objectUrl;
        this.subirDocumento(rfc, idDocument, file, index);
      }

      if (nombreArchivoAnterior) {
             // Mostrar confirmación al usuario
               Swal.fire({
               title: '¿Reemplazar archivo?',
               text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
               icon: 'warning',
               showCancelButton: true,
               confirmButtonColor: '#41bd00',
               cancelButtonColor: '#C71128',
               confirmButtonText: 'Sí, reemplazar',
               cancelButtonText: 'No, cancelar'
             }).then((result) => {
               if (result.isConfirmed) {
                 // Si el usuario confirma, eliminar el anterior
                 this.eliminarDocumentosService.eliminarDocumentos(idDocumentoAnterior, rfc, nombreArchivoAnterior).subscribe({
                   next: subir,
                   error: () => {
                     Swal.fire({
                       icon: 'error',
                       title: 'Error al eliminar documento anterior',
                       text: `No se pudo eliminar el documento anterior para ${doc.titulo}.`,
                       confirmButtonColor: '#A11A5C'
                     });
                   }
                 });
               }
             });
           } else {
            subir(); // Primera vez
             // Si no hay archivo anterior, subir directamente
             //this.subirDocumento(rfc, idDocument, file, index);
           }
    }
  }

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF3(event: Event, index:number): void {
    // console.log('Archivo seleccionado (evento):', event);
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana3(): void {
    if (this.archivoPDF3) {
      const url = URL.createObjectURL(this.archivoPDF3);
      window.open(url, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** REPUVE *********************************************//

  onFileSelecteded4(input: HTMLInputElement, index: number): void {
    const file = input.files?.[0];
    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      this.archivoPDF4 = file;
      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL4 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL4;
      // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc + datosPersona.homoClave;
      const idDocument = this.documentos[index].id;
      const doc = this.documentos[index];

      const nombreArchivoAnterior = this.identificadoresAnteriores[index];
      const idDocumentoAnterior = this.idsDocumentoAnteriores[index];

      const subir = () => {
        const objectUrl = URL.createObjectURL(file);
        const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

        this.archivoPDF4 = file;
        this.pdfURL4 = pdfSafeUrl;
        this.documentos[index].urlVisor = this.pdfURL4;
        this.documentos[index].rawUrl = objectUrl;
        this.subirDocumento(rfc, idDocument, file, index);
      }

      if (nombreArchivoAnterior) {
             // Mostrar confirmación al usuario
               Swal.fire({
               title: '¿Reemplazar archivo?',
               text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
               icon: 'warning',
               showCancelButton: true,
               confirmButtonColor: '#41bd00',
               cancelButtonColor: '#C71128',
               confirmButtonText: 'Sí, reemplazar',
               cancelButtonText: 'No, cancelar'
             }).then((result) => {
               if (result.isConfirmed) {
                 // Si el usuario confirma, eliminar el anterior
                 this.eliminarDocumentosService.eliminarDocumentos(idDocumentoAnterior, rfc, nombreArchivoAnterior).subscribe({
                   next: subir,
                   error: () => {
                     Swal.fire({
                       icon: 'error',
                       title: 'Error al eliminar documento anterior',
                       text: `No se pudo eliminar el documento anterior para ${doc.titulo}.`,
                       confirmButtonColor: '#A11A5C'
                     });
                   }
                 });
               }
             });
           } else {
            subir(); // Primera vez
             // Si no hay archivo anterior, subir directamente
             //this.subirDocumento(rfc, idDocument, file, index);
           }
    }
  }

  // Evento de selección (opcional)
  archivoSelecionadoPDF4(event: Event, index:number): void {
    //console.log('Archivo seleccionado (evento):', event);
  }

  // Abrir PDF en nueva pestaña
  abrirPDFNewVentana4(): void {
    if (this.archivoPDF4) {
      const url = URL.createObjectURL(this.archivoPDF4);
      window.open(url, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************FUNCIONES*********************************************** */

  // Méto do que "transfiere" valor automáticamente del RFC al CURP

  pasarValorRfcACurp(): void {
    const rfc = this.SegundoGrupo.get('rfc')?.value;

    if (rfc && rfc.length >= 10) {
      const curpParcial = rfc.substr(0, 10).toUpperCase(); // Convertir a mayúsculas
      this.SegundoGrupo.get('curp')?.setValue(curpParcial);
    } else {
      // Caso en que el RFC no tenga los caracteres necesarios
      this.SegundoGrupo.get('curp')?.setValue('');
    }
  }

  // funcion para abrir modal curp

  modalCURP() {
    Swal.fire({
      background: 'rgba(161, 26, 92)',
      imageUrl: '/assets/img/imagenesCuerpo/CURP.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `,
      },
      hideClass: {
        popup: `
                animate__animated
                animate__fadeOutDown
                animate__faster
              `,
      },
    });
  }

  // funcion para abrir modal rfc

  modalRFCFISICA() {
    Swal.fire({
      background: 'rgba(161, 26, 92)',
      imageUrl: '/assets/img/imagenesCuerpo/RFCFISICA.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `,
      },
      hideClass: {
        popup: `
                animate__animated
                animate__fadeOutDown
                animate__faster
              `,
      },
    });
  }

  // funcion para descargar documento



extractBirthday(): void {
    const rfc: string = this.SegundoGrupo.get('rfc')?.value;

    if (rfc && rfc.length >= 10) {
      // Obtener el año (posiciones 5 y 6 del RFC)
      let anio: string = rfc.substring(4, 6).trim();
      const anioInt: number = parseInt(anio, 10);

      if (anioInt > new Date().getFullYear() % 100 || anio === '00') {
        anio = (anio === '00') ? '2000' : '19' + anio;
      } else {
        anio = '20' + anio;
      }

      // Obtener mes y día
      const mes: string = rfc.substring(6, 8).trim();
      const dia: string = rfc.substring(8, 10).trim();

      const fechaNacimiento = `${anio}-${mes}-${dia}`;
      //console.log(fechaNacimiento);
      this.SegundoGrupo.get('fechaNacimiento')?.setValue(fechaNacimiento);
    } else {
      this.SegundoGrupo.get('fechaNacimiento')?.setValue('');
    }
  }


  extraerSexoDesdeCurp(): void {
    const curp: string = this.SegundoGrupo.get('curp')?.value;

    if (curp && curp.length >= 18) {
      const sexo = curp.charAt(10).toUpperCase();

      if (sexo === 'H') {
        this.SegundoGrupo.get('sexo')?.setValue('M');
      } else if (sexo === 'M') {
        this.SegundoGrupo.get('sexo')?.setValue('F');
      } else {
        this.SegundoGrupo.get('sexo')?.setValue('');
      }
    } else {
      this.SegundoGrupo.get('sexo')?.setValue('');
    }
  }
}



